import {
  COMPLETE_BUY_AIR,
  COMPLETE_BUY_CARS,
  LodgingCheckoutTrackingEvents,
} from "@hopper-b2b/types";
import {
  COMPLETE_BUY_ACTIVITY,
  COMPLETE_BUY_HOME,
  COMPLETE_BUY_PACKAGE,
} from "./trackingEvents";

/**
 * Every `complete_buy_*` event across LOBs. Assumption: this list is complete
 * and each of these events carries a boolean `success`. Any new
 * `complete_buy_*` event must be added here or its failures will leak into GTM.
 */
const PURCHASE_EVENTS: ReadonlySet<string> = new Set([
  COMPLETE_BUY_AIR,
  LodgingCheckoutTrackingEvents.hotel_complete_buy,
  COMPLETE_BUY_CARS,
  COMPLETE_BUY_HOME,
  COMPLETE_BUY_ACTIVITY,
  COMPLETE_BUY_PACKAGE,
]);

/**
 * Gate in front of the GA Tag Manager push, applied at the RBC fan-out
 * (`AppTrackingProvider.usePublishEvent`).
 *
 * RBC's GTM treats `complete_buy_*` as a purchase, so a failed fulfillment must
 * not reach it. The checkout machines fire the same event name on failure with
 * `success: false` (see `trackPollFailure` and the package fulfill action), and
 * HTS still needs those, so the filter lives here rather than in the machine.
 * Every event outside `PURCHASE_EVENTS` is pushed unchanged, failures included.
 *
 * @param eventName HTS event name as fired.
 * @param properties Enriched event properties, checked for `success`.
 * @returns False only for a `complete_buy_*` event with `success === false`.
 */
export const shouldPushToDataLayer = (
  eventName: string,
  properties: Record<string, unknown> | undefined
): boolean => !PURCHASE_EVENTS.has(eventName) || properties?.success !== false;
